import React, { useContext } from 'react'
import JDFrame from './JDFrame'
import BasketStatus from './BasketStatus'
import BasketDiscounts from './BasketDiscounts'
import Basket from './Basket'
import AppContext from '../context'
import PaymentStatus from './PaymentStatus'

interface Props {

}

const Layout: React.FC<Props> = () => {
    const { state, paymentProgress, updatePaymentProgress, resetPayment } = useContext(AppContext)

    const renderBuyingState = () => (
        <div className="row">
            <JDFrame />
            <div className="row column basket-info">
                <BasketStatus />
                <BasketDiscounts />
            </div>
            <Basket />
        </div>
    )

    const renderPayingState = () => (
        <div className="row">
            <PaymentStatus 
                paymentStatus={paymentProgress}
                updatePaymentStatus={updatePaymentProgress}
                onReset={resetPayment}
            />
            <Basket />
        </div>
    )

    switch (state) {
        case "buying":
            return renderBuyingState();
        case "paying":
        case "finished":
            return renderPayingState();
        default:
            throw new Error("Invalid State")
    }
}

export default Layout
